/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Contactlastname_Label2Inputs */

const en_company_registration_contactlastname_label2 = /** @type {(inputs: Company_Registration_Contactlastname_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Last Name`)
};

const de_company_registration_contactlastname_label2 = /** @type {(inputs: Company_Registration_Contactlastname_Label2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachname der Kontaktperson`)
};

/**
* | output |
* | --- |
* | "Contact Last Name" |
*
* @param {Company_Registration_Contactlastname_Label2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const company_registration_contactlastname_label2 = /** @type {((inputs?: Company_Registration_Contactlastname_Label2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Contactlastname_Label2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_contactlastname_label2(inputs)
	return en_company_registration_contactlastname_label2(inputs)
});
export { company_registration_contactlastname_label2 as "company_registration_contactLastName_label" }